import dynamic from 'next/dynamic'

import LazyLoad from '@/lib/lazyload'

import type { Props } from './view'

const DynamicContact = dynamic(() => {
  return import('./view')
})

const LazyContact = (props: Props): React.ReactElement => (
  <LazyLoad>
    <DynamicContact {...props} />
  </LazyLoad>
)
export default LazyContact
